import React from 'react';
import {RenderLeafProps} from 'slate-react';

import {useCommentStore} from '../../../store/reportStore/commentStore';
import {useEditorUI} from '../editor-core/contexts/EditorUIContext';

export const LeafRenderer = (props: RenderLeafProps): React.JSX.Element => {
  let {children} = props;
  const {attributes, leaf} = props;
  const activeCommentNodeId = useCommentStore((s) => s.activeCommentNodeId);
  const setActiveCommentNodeId = useCommentStore(
    (s) => s.setActiveCommentNodeId
  );
  const {setCommentPanelOpen} = useEditorUI();

  if (leaf.bold) children = <strong>{children}</strong>;
  if (leaf.italic) children = <em>{children}</em>;
  if (leaf.underline) children = <u>{children}</u>;
  if (leaf.superscript) children = <sup>{children}</sup>;
  if (leaf.subscript) children = <sub>{children}</sub>;
  if (leaf.code)
    children = (
      <code
        style={{backgroundColor: '#eee', padding: '2px 4px', borderRadius: 2}}
      >
        {children}
      </code>
    );
  const baseStyle: React.CSSProperties = {
    fontSize: leaf.fontSize ? `${leaf.fontSize}px` : undefined,
    fontFamily: leaf.fontFamily,
    color: leaf.color,
    ...(leaf.strikethrough ? {textDecorationLine: 'line-through'} : {})
  };

  if (leaf.commentThreadId) {
    const isActive = leaf.commentThreadId === activeCommentNodeId;
    const isResolved = leaf.commentThreadResolved === true;
    const commentRefClass = [
      'comment-thread-ref',
      isResolved && 'comment-thread-ref--resolved',
      !isResolved && isActive && 'comment-thread-ref--active'
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <span
        {...attributes}
        style={baseStyle}
        className={commentRefClass}
        data-thread-id={leaf.commentThreadId}
        onClick={(e) => {
          e.stopPropagation();
          setCommentPanelOpen(false);
          setActiveCommentNodeId(leaf.commentThreadId as string);
        }}
      >
        {children}
      </span>
    );
  }

  const s: React.CSSProperties = {
    ...baseStyle,
    backgroundColor: leaf.highlight
  };
  if (leaf.multiSelection) s.backgroundColor = '#b3d7ff';

  if (leaf.comment) {
    return (
      <span {...attributes} style={baseStyle} className="comment-thread-ref">
        {children}
      </span>
    );
  }

  return (
    <span style={s} {...attributes}>
      {children}
    </span>
  );
};
